//オリジナルjquery
$(document).ready(function(){
  // ページ読み込み時にbg-noneクラスを追加する
  $('.header-wrapper, .header-background-blur, .bg-blur, .header__icon, .icon-close, .drawer__inner, .link--text, .cart-drawer__empty-content, .menu-drawer__navigation-container, .cart-count-bubble').addClass('bg-none');
  
  $(window).scroll(function(){
    if($(this).scrollTop() > $(window).height()) {
      $('.header-wrapper, .header-background-blur, .bg-blur, .header__icon, .icon-close, .drawer__inner, .link--text, .cart-drawer__empty-content, .menu-drawer__navigation-container, .cart-count-bubble').removeClass('bg-none');
    } else {
      $('.header-wrapper, .header-background-blur, .bg-blur, .header__icon, .icon-close, .drawer__inner, .link--text, .cart-drawer__empty-content, .menu-drawer__navigation-container, .cart-count-bubble').addClass('bg-none');
    }
  });
});